import { render, staticRenderFns } from "./SingleVideo.vue?vue&type=template&id=fb4e005e&"
import script from "./SingleVideo.vue?vue&type=script&lang=js&"
export * from "./SingleVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports